import { useRouter } from "../routing/router";

const toObjectPass = (params = {}) => {
  const router = useRouter();
  const buildingId = params["row_id"];
  router.push({ name: "object_pass", query: { building_id: buildingId } });
};

export { toObjectPass };
